// extracted by mini-css-extract-plugin
export default {"image":"m3-z","loaded":"n3-z"};